import React from 'react';

const CorporateSchool = () => {
  return (
    <div>
      
    </div>
  );
};

export default CorporateSchool;